import { Button } from "antd";
import styles from "./CardView.module.scss";
import TimeDown from "../../components/timedown/timedown";
import { complexDigitToman } from "../../tools/tools";
import { useNavigate } from "react-router-dom";
import { _adr } from "../../address";

const CardView = ({ item }) => {
  const nav = useNavigate();
  const switchTagBag = (type = 0) => {
    switch (type) {
      case 0:
        return "gold";
      case 1:
        return "platinum";
      case 2:
        return "silver";
      case 3:
        return "bronze";
      case 4:
        return "aptel";
      default:
        return "";
    }
  };
  return (
    <>
      <div className={styles.showpackageCardglobal}>
        <div className={styles.header} data-type={switchTagBag(item?.auctionProductTypeiId)}>
          <div className={styles.row_header}>
            <div className={styles.title}>
              <h4>{item.auctionProductType}</h4>
            </div>
            <div className={styles.msisdn}>
              <h3>{item?.auctionTitle}</h3>
              <span>{item?.bundle?.bundleName}</span>
            </div>
          </div>
        </div>
        <div className={styles.body}>
          <ul>
            <li>
              <div className={styles.label}>بالاترین پیشنهاد:</div>
              <div className={styles.value}>
                <span>{complexDigitToman(item?.maxBid)} </span> تومان
              </div>
            </li>
            <li>
              <div className={styles.label}>قیمت شروع:</div>
              <div className={styles.value}>
                <span>{complexDigitToman(item?.startPrice)}</span> تومان 
              </div>
            </li>
          </ul>
          {item?.userBid > 0 ? (
            <div className={styles.preferPrice}>
              <h4>قیمت پیشنهادی شما</h4>
              <div className={styles.price}>
                <span dir="ltr">{complexDigitToman(item?.userBid)}</span> تومان
              </div>
            </div>
          ) : (
            <div className={styles.holdCounter}>
              <h4>مهلت شرکت در حراجی:</h4>
              <div className={styles.counterTime}>
                <TimeDown datetime={new Date(item?.endDate)} />
              </div>
            </div>
          )}
        </div>
        <div className={styles.bodyFooter}>
          <div className="holder-button" style={{ textAlign: "center" }}>
            <Button
              className={`btn-normal ${styles.btnNormal}`}
              onClick={(e) => nav(_adr.Root + _adr.Landing.Index + _adr.Landing.Details + `?id=${item?.auctionProductId}`)}
            >
              مشاهده جزئیات و ارائه پیشنهاد
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default CardView;
